"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var event_1 = require("./event");
var EventWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(EventWrapper, _super);
    function EventWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.observerList = [];
        _this.on = function (event, callback) {
            event_1.EventCenter.on(event, callback);
            var observer = function () { return event_1.EventCenter.removeListener(event, callback); };
            _this.observerList.push(observer);
            return observer;
        };
        _this.once = function (event, callback) {
            event_1.EventCenter.once(event, callback);
            var observer = function () { return event_1.EventCenter.removeListener(event, callback); };
            _this.observerList.push(observer);
            return observer;
        };
        _this.emit = function (event, info) {
            event_1.EventCenter.emit(event, info);
        };
        return _this;
    }
    EventWrapper.prototype.componentWillUnmount = function () {
        this.observerList.forEach(function (observer) { return observer(); });
    };
    EventWrapper.prototype.render = function () {
        var _a = this.props, Cp = _a.Cp, originProps = _a.originProps;
        return react_1.default.createElement(Cp, tslib_1.__assign({}, originProps, { on: this.on, once: this.once, emit: this.emit }));
    };
    return EventWrapper;
}(react_1.default.PureComponent));
exports.EventWrapper = EventWrapper;
function EventWrapperDecorator(Cp) {
    return function (props) { return react_1.default.createElement(EventWrapper, { Cp: Cp, originProps: props }); };
}
exports.default = EventWrapperDecorator;
//# sourceMappingURL=EventWrapper.js.map